import {useAttendeeVariables} from 'Event'
import {useAddTranslation} from 'Event/LanguageProvider'
import {useTemplate} from 'Event/TemplateProvider'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import HTMLEditor, {HTMLEditorContainer} from 'lib/ui/form/HTMLEditor'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import React from 'react'
import {Controller} from 'react-hook-form'

export default function AdditionalContentConfig() {
  const {techCheck} = useTemplate()
  const save = useSaveTemplate()
  const addTranslation = useAddTranslation()

  const handleSave = (data: any) => {
    const content = replaceAtPath(
      data,
      'techCheck.additionalContent',
      '{{tech_check_additional_content}}',
    )
    save({
      ...data,
      localization: addTranslation({
        tech_check_additional_content: content ?? '',
      }),
    })
  }

  const {
    form: {control},
  } = useConfig()

  const v = useAttendeeVariables()

  return (
    <Config title="Additional Content" onSave={handleSave}>
      <SettingsPanel>
        <HTMLEditorContainer>
          <Controller
            name="techCheck.additionalContent"
            defaultValue={v(techCheck.additionalContent)}
            control={control}
            render={({value, onChange}) => (
              <HTMLEditor data={value} onChange={onChange} />
            )}
          />
        </HTMLEditorContainer>
      </SettingsPanel>
    </Config>
  )
}
